import { LicenseConfigurationPanel } from "@/components/non_registrant/license-configuration-panel";
import { SETUP_PAGE_SHELL_CLASS } from "@/components/portal/setup-page-layout";
import LoadingScreen from "@/components/ui/loading-screen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/license-configuration")({
  component: LicenseConfigurationPage,
});

function LicenseConfigurationPage() {
  const { isAuthSetupComplete } = useAuthQuerySetup();

  if (!isAuthSetupComplete) {
    return <LoadingScreen />;
  }

  return (
    <div className={SETUP_PAGE_SHELL_CLASS}>
      <LicenseConfigurationPanel />
    </div>
  );
}
